import React from 'react'
import { useEffect, useState } from "react";
import GetIcon from "../../../../utils/Icon";
import FormLayout from "../../../../Core/Layout/FormLayout";
import { useGetBrandByNameQuery } from '../../../../store/api/barand_master'; 
import ApiResponseBox from '../../../../Components/ApiResponseBox';
import Tab1 from "./Tab1";
import { useLocation } from 'react-router-dom';
import Attachment from '../../../../utils/Attachment';

function Brand() {
  const location = useLocation()
  const brandName = location?.state.PurchaseId
  const [tab, settab] = useState(1)
  const [res, setRes] = useState(false)
  const [brand, setBrand] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState('');
  const [ptype, setptype] = useState("Error")
  const [showError, setShowError] = useState(false);
  const { data, isLoading } = useGetBrandByNameQuery(brandName);

  useEffect(() => {
  if (data?.data) {
    setBrand(data.data.name || '');
    setDescription(data.data.description || '');
  }
  }, [data]);
  return (
    <>
      <FormLayout
        title="View Brand"
        breadcrumbs={[
          { label: "Brand" },
          { label: "Brand List", url: "/master/brand/brand-list" }
        ]}
        status={'hide'}
        finalStep={true} 
      >
        <div className="" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff"  ,flexGrow:'1'}}>
          <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
            <div className="d-flex justify-content-between align-items-end ">
              <ul className="nav nav-tabs" style={{ color: "white", border: "none" }}>
                <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner" >
                  <a className={tab == 1 ? "removeborder234 nav-link active-tab-custom text-white border-radius-top-corner" : "removeborder234 nav-link nav-link-tab-custom bg-white border-radius-top-corner"} onClick={() => { settab(1) }} href="javascript:void(0);">
                    General Details{tab == 1 ? <GetIcon iconName="MdKeyboardArrowDown" size={15} /> : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                  </a>
                </li>
              </ul>
             <Attachment doctype="Brand"  docname={brandName}  /> 

            </div>
          </div>
          <div className="mt-2 py-2" style={{ width: "100%", overflow: "hidden", backgroundColor: "#fff" }}>
            <div className="row d-flex justify-content-between">
              <div className="col-12" >
                <div className="sidebarbox m-0 px-4 py-2">
                  <Tab1 setBrand={setBrand} setDescription={setDescription} brand={brand} description={description} brandName={brandName} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ApiResponseBox
          poptype={ptype}
          show={showError}
          errorMessage={error}
          onClose={() => setShowError(false)}
        />
      </FormLayout>
    </>
  )
}
export default Brand
